export function fuzzyScore(text, query) {
  if (!query) return 1;
  if (!text) return 0;

  const haystack = text.toLowerCase();
  const needle = query.toLowerCase();

  let position = 0;
  let score = 0;

  for (let index = 0; index < needle.length; index += 1) {
    const char = needle[index];
    const foundIndex = haystack.indexOf(char, position);
    if (foundIndex === -1) {
      return 0;
    }

    score += foundIndex === position ? 2 : 1;
    if (foundIndex === 0 || /[^a-z0-9]/.test(haystack[foundIndex - 1])) {
      score += 1;
    }

    position = foundIndex + 1;
  }

  const lengthFactor = Math.max(1, position - needle.length + 1);
  return score / lengthFactor;
}

export function escapeHtml(value) {
  return (value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

export function highlightSnippet(text, term, radius = 40) {
  if (!text || !term) return "";

  const lowerText = text.toLowerCase();
  const lowerTerm = term.toLowerCase();
  const matchIndex = lowerText.indexOf(lowerTerm);

  if (matchIndex === -1) {
    return "";
  }

  const start = Math.max(0, matchIndex - radius);
  const end = Math.min(text.length, matchIndex + term.length + radius);

  const prefix = escapeHtml(text.slice(start, matchIndex));
  const match = escapeHtml(text.slice(matchIndex, matchIndex + term.length));
  const suffix = escapeHtml(text.slice(matchIndex + term.length, end));

  const prefixEllipsis = start > 0 ? "..." : "";
  const suffixEllipsis = end < text.length ? "..." : "";

  return `${prefixEllipsis}${prefix}<mark>${match}</mark>${suffix}${suffixEllipsis}`;
}

export function highlightDisplayName(name, term) {
  if (!name) return "";
  if (!term) return escapeHtml(name);
  const lowerName = name.toLowerCase();
  const lowerTerm = term.toLowerCase();
  const matchIndex = lowerName.indexOf(lowerTerm);
  if (matchIndex === -1) {
    return escapeHtml(name);
  }
  const prefix = escapeHtml(name.slice(0, matchIndex));
  const match = escapeHtml(name.slice(matchIndex, matchIndex + term.length));
  const suffix = escapeHtml(name.slice(matchIndex + term.length));
  return `${prefix}<mark>${match}</mark>${suffix}`;
}
